export default "__VITE_ASSET__Dzb0ltgM__"